import React from 'react';

type Props = {
    children: React.ReactNode;
};

const RouteGuard = ({children}: Props): React.JSX.Element => {
    return (
        <>
            {children}
        </>
    );
};

export default RouteGuard;